import { Component, Inject, OnInit } from '@angular/core';
import { addDays, isBefore } from 'date-fns';
import { DialogRef } from '../../dialog/dialog-ref';
import { DATA, DIALOG } from '../../dialog/dialog.service';

export interface PostponeDialogResult {
  days: number;
  date: Date;
}

@Component({
  selector: 'app-postpone-plan-dialog',
  templateUrl: './postpone-plan-dialog.component.html',
  styleUrls: ['./postpone-plan-dialog.component.scss']
})
export class PostponePlanDialogComponent {

  days = 7;
  date = addDays(new Date(), 1);

  constructor(@Inject(DIALOG) private dialog: DialogRef) {
  }

  cancel() {
    this.dialog.close();
  }

  accept() {
    this.dialog.close({days: this.days, date: this.date} as PostponeDialogResult);
  }

  get invalidDate() {
    return isBefore(this.date, new Date());
  }
}
